var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.23L12.58 21.81C12.88 21.6 20 16.44 20 10C20 7.87827 19.1571 5.84344 17.6569 4.34315C16.1566 2.84285 14.1217 2 12 2C9.87827 2 7.84344 2.84285 6.34315 4.34315C4.84285 5.84344 4 7.87827 4 10C4 16.44 11.12 21.6 11.42 21.81L12 22.23Z",
    fill: "#FF4242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 9.26768C10.728 9.19045 11.216 8.80432 11.0229 7.8776C10.8299 6.95089 10.2453 6.35882 9.9772 6.17863C9.62862 6.41031 9.01191 7.13623 9.33368 8.18651C9.65544 9.23679 10.2185 9.3449 10.4599 9.26768Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2058 10.735C15.5544 10.8379 16.3481 10.8276 16.7342 9.96271C17.1203 9.09778 17.0023 8.41819 16.8951 8.18651C16.4929 8.16077 15.5598 8.34096 15.045 9.26768C14.5301 10.1944 14.9377 10.632 15.2058 10.735Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85105 10.1172C9.04411 10.5496 8.93149 10.9152 8.85105 11.0439C8.58292 11.1726 7.91794 11.291 7.40312 10.735C6.8883 10.1789 6.97411 9.37064 7.08136 9.036C7.80532 8.95877 8.60973 9.57658 8.85105 10.1172Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9188 12.125C13.7579 12.0736 13.4201 11.7853 13.3557 11.0439C13.2914 10.3025 12.8463 10.529 12.6317 10.735C12.4172 10.8122 11.8917 10.9203 11.5056 10.735C11.0349 10.509 10.9467 10.6503 10.7188 11.0156L10.7012 11.0439C10.6338 11.1516 10.579 11.2714 10.521 11.3981C10.3711 11.7256 10.1999 12.0999 9.73589 12.434C9.22108 12.8046 9.52139 13.2577 9.73589 13.4379C9.78952 13.5409 10.0094 13.7468 10.4599 13.7468C10.6123 13.7468 10.753 13.7298 10.8947 13.7127C11.2762 13.6666 11.6648 13.6197 12.31 13.9012C13.0179 14.2102 14.0529 13.7211 14.4819 13.4379C14.7232 13.232 14.9484 12.6811 13.9188 12.125Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1277 9.22612C13.4522 9.25924 14.1212 9.04167 14.2013 7.90639C14.2489 7.23135 14.1359 6.66865 13.995 6.26727C13.8834 5.94947 13.4802 5.90701 13.2786 6.18339C13.0306 6.52316 12.7705 6.98317 12.6545 7.49328C12.4134 8.55342 12.3543 9.01956 13.1277 9.22612Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecies);
export default __webpack_public_path__ + "static/media/Species.a4141b40d6a4f39677af1216edf6d8f0.svg";
export { ForwardRef as ReactComponent };